import React from "react";
import MessageIcon from "../platform/svg/MessageIcon";
import classes from "./Chat.module.css";

type Props = {
  isOpen: boolean;
  isHidden?: boolean;
  onToggle: () => void;
};

const ChatLauncher = ({
  isOpen,
  isHidden = false,
  onToggle,
}: Props) => {
  return (
    <button
      type="button"
      className={`${classes.launcherButton} ${
        isOpen ? classes.launcherButtonActive : ""
      } ${isHidden ? classes.launcherButtonHidden : ""}`}
      aria-expanded={isOpen}
      aria-label={isOpen ? "Close chat" : "Open chat"}
      onClick={onToggle}
    >
      {isOpen ? (
        <span className={classes.launcherCloseIcon} aria-hidden="true">
          <span />
          <span />
        </span>
      ) : (
        <MessageIcon />
      )}
    </button>
  );
};

export default ChatLauncher;
